const desktopFHD = {
    val: 1920,
    columns: 12,
    padding: 20,
    margin: 32,
    verticalUnit: 32
};
const desktopHD = {
    val: 1680,
    columns: 12,
    padding: 20,
    margin: 32,
    verticalUnit: 32
};
const desktopM = {
    val: 1440,
    columns: 12,
    padding: 20,
    margin: 32,
    verticalUnit: 32
};
const desktop = {
    val: 1280,
    columns: 12,
    padding: 20,
    margin: 32,
    verticalUnit: 32
};
const tablet = {
    val: 1024,
    columns: 12,
    padding: 20,
    margin: 32,
    verticalUnit: 32
};
const mobileL = {
    val: 768,
    columns: 4,
    padding: 20,
    margin: 20,
    verticalUnit: 20
};
const mobileS = {
    val: 480,
    columns: 4,
    padding: 20,
    margin: 20,
    verticalUnit: 20
};
const breakpoints = {
    desktopFHD,
    desktopHD,
    desktopM,
    desktop,
    tablet,
    mobileL,
    mobileS
};
const device = {
    desktopFHD: `(max-width: ${breakpoints.desktopFHD.val - 1}px)`,
    desktopHD: `(max-width: ${breakpoints.desktopHD.val - 1}px)`,
    desktopM: `(max-width: ${breakpoints.desktopM.val - 1}px)`,
    desktop: `(max-width: ${breakpoints.desktop.val - 1}px)`,
    tablet: `(max-width: ${breakpoints.tablet.val - 1}px)`,
    mobileL: `(max-width: ${breakpoints.mobileL.val - 1}px)`,
    mobileS: `(max-width: ${breakpoints.mobileS.val - 1}px)`
};const colors = {
    primary: {
        success: '#00B469',
        warning: '#F2B000',
        error: '#F34E16',
        accent: '#2044FF',
        fill100: '#0F1011',
        fill95: '#1D1E1F',
        text60: '#6F7070',
        text40: '#868787',
        fill5: '#F4F4F4',
        fill0: '#FFFFFF'
    },
    secondary: {
        accent: '#617BFF',
        error: '#D13400',
        success: '#00804A',
        warning: '#8F6900',
        purpleDark: '#AD4E89',
        cyanDark: '#003D44',
        purpleMedium: '#D7BDCD',
        cyanMedium: '#00CFE6'
    },
    extended: {
        fill90: '#232425',
        fill80: '#2C2D30',
        fill50: '#7A7A7A',
        fill30: '#969696',
        fill20: '#BABABA',
        fill10: '#E8E8E8',
        fill7: '#EDEDED',
        fill3: '#FAFAFA',
        blueLight: '#E5EAFF',
        redLight: '#FFF2ED',
        greenLight: '#E9F5F3',
        yellowLight: '#FFF3D4',
        purpleLight: '#FFF2FA',
        cyanLight: '#D7EEF0'
    },
    states: {
        accentHover: '#294BFF',
        accentPressed: '#3354FF',
        hoverDark: '#232425',
        pressedDark: '#2C2D30',
        hoverOnWhite: '#EDEDED',
        pressedLight: '#E8E8E8',
        hoverOnGrey: '#FAFAFA',
        disabledDark: '#2C2D30',
        hoverOnGreyButton: '#DEDEDE',
        pressedOnGreyButton: '#D3D3D3',
        disabledLight: '#EDEDED',
        disabledGrey: '#D3D3D3'
    },
    opacity: {
        w80: 'rgba(255, 255, 255, 0.8)',
        w60: 'rgba(255, 255, 255, 0.6)',
        w40: 'rgba(255, 255, 255, 0.4)',
        w20: 'rgba(255, 255, 255, 0.2)',
        w10: 'rgba(255, 255, 255, 0.1)',
        w08: 'rgba(255, 255, 255, 0.08)',
        w06: 'rgba(255, 255, 255, 0.06)',
        w04: 'rgba(255, 255, 255, 0.04)',
        w02: 'rgba(255, 255, 255, 0.02)',
        d80: 'rgba(15, 16, 17, 0.8)',
        d60: 'rgba(15, 16, 17, 0.6)',
        d40: 'rgba(15, 16, 17, 0.4)',
        d20: 'rgba(15, 16, 17, 0.2)',
        d10: 'rgba(15, 16, 17, 0.1)',
        d08: 'rgba(15, 16, 17, 0.08)',
        d06: 'rgba(15, 16, 17, 0.06)',
        d04: 'rgba(15, 16, 17, 0.04)',
        d02: 'rgba(15, 16, 17, 0.02)'
    }
};const maxContentWidth = 1792;const transitions = {
    functions: {
        cubicBezier0_76: 'cubic-bezier(0.76, 0, 0.24, 1)'
    },
    time: {
        s0_3: '0.3s'
    }
};const scrims = {
    gradient: `linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.6) 0%,
        rgba(0, 0, 0, 0.59) 6.67%,
        rgba(0, 0, 0, 0.58) 13.33%,
        rgba(0, 0, 0, 0.55) 20%,
        rgba(0, 0, 0, 0.51) 26.67%,
        rgba(0, 0, 0, 0.46) 33.33%,
        rgba(0, 0, 0, 0.40) 40%,
        rgba(0, 0, 0, 0.33) 46.67%,
        rgba(0, 0, 0, 0.27) 53.33%,
        rgba(0, 0, 0, 0.20) 60%,
        rgba(0, 0, 0, 0.14) 66.67%,
        rgba(0, 0, 0, 0.09) 73.33%,
        rgba(0, 0, 0, 0.049) 80%,
        rgba(0, 0, 0, 0.021) 86.67%,
        rgba(0, 0, 0, 0.005) 93.33%,
        rgba(0, 0, 0, 0) 100%
    )`
};export{breakpoints,colors,device,maxContentWidth,scrims,transitions};